import { render, staticRenderFns } from "./ProductsDisplay.vue?vue&type=template&id=a85a5f78&scoped=true"
import script from "./ProductsDisplay.vue?vue&type=script&lang=js"
export * from "./ProductsDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductsDisplay.vue?vue&type=style&index=0&id=a85a5f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85a5f78",
  null
  
)

export default component.exports